import { panelStyle } from "./theme";

export default function AdminPanel({ children }) {
  return <div style={panelStyle}>{children}</div>;
}
